import React from 'react'

export default (props) => (
  <svg width="34" height="50" viewBox="0 0 34 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.33333 50C12.9333 50 16.6667 46.2667 16.6667 41.6667V33.3334H8.33333C3.73333 33.3334 0 37.0667 0 41.6667C0 46.2667 3.73333 50 8.33333 50Z" fill="#0ACF83" />
    <path d="M0 25C0 20.4 3.73333 16.6666 8.33333 16.6666H16.6667V33.3333H8.33333C3.73333 33.3333 0 29.6 0 25Z" fill="#A259FF" />
    <path d="M0 8.33333C0 3.73333 3.73333 0 8.33333 0H16.6667V16.6667H8.33333C3.73333 16.6667 0 12.9333 0 8.33333Z" fill="#F24E1E" />
    <path d="M16.6665 0H24.9998C29.5998 0 33.3332 3.73333 33.3332 8.33333C33.3332 12.9333 29.5998 16.6667 24.9998 16.6667H16.6665V0Z" fill="#FF7262" />
    <path d="M33.3332 25C33.3332 29.6 29.5998 33.3333 24.9998 33.3333C20.3998 33.3333 16.6665 29.6 16.6665 25C16.6665 20.4 20.3998 16.6666 24.9998 16.6666C29.5998 16.6666 33.3332 20.4 33.3332 25Z" fill="#1ABCFE" />
  </svg>

)